import React, { useState } from 'react';
import { Box } from '@mui/material';
import {
  AppliedFilters,
  DataTable,
  FilterSearch,
  MainLayout,
} from '../../../../../../ui';
import { data } from './Constants/data';
import { CreateNewQuestion, SelectQuestions } from './Containers';
import { getColumns, getFilterLabels } from './Functions';
import { useQuestions } from './Hooks';

export const Questions: React.FC = () => {
  const {
    handleSearch,
    handleApplyFilters,
    handleRemoveFilter,
    handleClearFilters,
    appliedFilters,
  } = useQuestions();
  const [isCreateNewDrawerOpen, setIsCreateNewDrawerOpen] = useState(false);
  const [isSelectQuestionDrawerOpen, setIsSelectQuestionDrawerOpen] =
    useState(false);

  return (
    <>
      <MainLayout>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <FilterSearch
              filterOptions={getFilterLabels()}
              onSearch={handleSearch}
              onApplyFilters={handleApplyFilters}
            />
          </Box>
          {appliedFilters.length > 0 && (
            <AppliedFilters
              appliedFilters={appliedFilters}
              handleClearFilters={handleClearFilters}
              handleRemoveFilter={handleRemoveFilter}
            />
          )}

          <Box sx={{ position: 'relative', width: '100%', height: '100%', overflowX: 'auto' }}>
            <DataTable
              columns={getColumns()}
              data={data}
              rowsPerPage={10}
              currentPage={0}
              onPageChange={() => {}}
              totalPages={0}
              hasCheckBox
              hidePagination
              totalRecords={data.length}
            />
          </Box>
        </Box>
      </MainLayout>
      <CreateNewQuestion
        isOpen={isCreateNewDrawerOpen}
        onCloseDrawer={() => setIsCreateNewDrawerOpen(false)}
      />
      <SelectQuestions
        isOpen={isSelectQuestionDrawerOpen}
        onCloseDrawer={() => setIsSelectQuestionDrawerOpen(false)}
      />
    </>
  );
};

export default Questions;
